export default {
  en: {
    spush_page__amount: 'Amount',
    spush_page__info: 'Scan this code with your mobile’s QR scanner',
    spush_page__footer: "Can't scan the QR?",
    spush_page__go_back: 'Go back',
    spush_page__deeplink: 'Pay with Spush Wallet',
  },
  de: {
    spush_page__amount: 'Betrag',
    spush_page__info: 'Scannen Sie diesen Code mit dem QR-Scanner Ihres Handys',
    spush_page__footer: 'Können Sie den QR nicht scannen?',
    spush_page__go_back: 'Geh zurück',
    spush_page__deeplink: 'Mit Spush Wallet bezahlen',
  },
  es: {
    spush_page__amount: 'Cantidad',
    spush_page__info: 'Escanea este código con el escáner QR de tu móvil',
    spush_page__footer: '¿No puedes escanear el QR?',
    spush_page__go_back: 'Regresar',
    spush_page__deeplink: 'Pagar con Spush Wallet',
  },
  pt: {
    spush_page__amount: 'Quantidade',
    spush_page__info: 'Escaneie este código com o scanner QR do seu celular',
    spush_page__footer: 'Não consegue escanear o QR?',
    spush_page__go_back: 'Voltar',
    spush_page__deeplink: 'Pagar com Spush Wallet',
  },
  tr: {
    spush_page__amount: 'Miktar',
    spush_page__info: 'Bu kodu mobil QR tarayıcınızla tarayın',
    spush_page__footer: "QR'ı tarayamıyor musunuz?",
    spush_page__go_back: 'Geri dön',
    spush_page__deeplink: 'Spush Wallet ile öde',
  },
  fr: {
    spush_page__amount: 'Montant',
    spush_page__info: 'Scannez ce code avec le scanner QR de votre mobile',
    spush_page__footer: 'Vous ne pouvez pas scanner le QR?',
    spush_page__go_back: 'Retourner',
    spush_page__deeplink: 'Payer avec Spush Wallet',
  },
  it: {
    spush_page__amount: 'Importo',
    spush_page__info: 'Scansiona questo codice con il QR scanner del tuo cellulare',
    spush_page__footer: 'Non riesci a scansionare il QR?',
    spush_page__go_back: 'Ritorno',
    spush_page__deeplink: 'Paga con Spush Wallet',
  },
};
